export default [
    {
        "id":601,
        "title":"JavaScript 核心原理精讲",
        "brief":"夯实 JavaScript 基本功，跨越前端进阶门槛",
        "image":"https://s0.lgstatic.com/i/image6/M01/60/E8/Cgp9HWGMxRSAWHDnAADwxLL_pbM113.png",
        "href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d601%26sid%3d20-h5Url-0",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d601%26sid%3d20-h5Url-0",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"390",
        "hasBuy":true,
        "teacherName":"若离",
        "teacherTitle":"前美团前端技术专家",
        "pruchasedCount":"1.22w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":531,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            2
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":18,
        "title":"12步通关求职面试",
        "brief":"资深 HRD 教你轻松拿到满意 Offer",
        "image":"https://s0.lgstatic.com/i/image/M00/63/47/Ciqc1F-WN-qAL4o2AADWKJFOwrA093.png",
        "href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D18%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D18%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "openWebToStudy":null,
        "courseType":1,
        "price":"48",
        "originalPrice":null,
        "duration":"120",
        "hasBuy":false,
        "teacherName":"杨宇堃",
        "teacherTitle":"拉勾网招聘总监",
        "pruchasedCount":"8233人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":246,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            8,
            9
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":1,
        "title":"32个Java面试必考点",
        "brief":"从原理到实战，全面提升你的Java核心技能",
        "image":"https://s0.lgstatic.com/i/image6/M01/3B/E3/Cgp9HWCHjGaATRwpAACVu9DlcII174.jpg",
        "href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d1%26sid%3d3-App_kaiwu_course-0",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d1%26sid%3d3-App_kaiwu_course-0",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"300",
        "hasBuy":true,
        "teacherName":"张雷",
        "teacherTitle":"新浪微博资深技术专家",
        "pruchasedCount":"3.01w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":233,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            1,
            9
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":4,
        "title":"如何高效准备简历和面试",
        "brief":"教你避开80%技术人求职都吃过的亏",
        "image":"https://s0.lgstatic.com/i/image/M00/5B/9B/Ciqc1F9_z82AC9JSAADRldtLRv0979.png",
        "href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D4%26sid%3D40-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D4%26sid%3D40-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "openWebToStudy":null,
        "courseType":1,
        "price":"68",
        "originalPrice":null,
        "duration":"60",
        "hasBuy":false,
        "teacherName":"吴文娟",
        "teacherTitle":"拉勾金牌职业规划师",
        "pruchasedCount":"1.48w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":245,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            8
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":3,
        "title":"300分钟搞定数据结构与算法",
        "brief":"力扣（Leetcode）刷题秘籍首次公开",
        "image":"https://s0.lgstatic.com/i/image/M00/5B/9B/Ciqc1F9_0HaADKqhAADn9L3IVkk671.png",
        "href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D3%26sid%3D30-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D3%26sid%3D30-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"300",
        "hasBuy":false,
        "teacherName":"Leetcode",
        "teacherTitle":"全球极客技术成长平台",
        "pruchasedCount":"5.03w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":240,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            1,
            2,
            6
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":88,
        "title":"Webpack原理与实践",
        "brief":"把知识打包，成为真正的前端高手",
        "image":"https://s0.lgstatic.com/i/image/M00/5B/98/Ciqc1F9_zYGAI-CtAABbq0iGM6Y060.jpg",
        "href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d88%26sid%3d20-h5Url-0",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d88%26sid%3d20-h5Url-0",
        "openWebToStudy":null,
        "courseType":1,
        "price":"48",
        "originalPrice":null,
        "duration":"200",
        "hasBuy":true,
        "teacherName":"行痴",
        "teacherTitle":"拉勾资深前端技术专家",
        "pruchasedCount":"9812人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":71,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            2
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":592,
        "title":"架构设计面试精讲",
        "brief":"专攻架构设计面试，剑指大厂高薪 Offer",
        "image":"https://s0.lgstatic.com/i/image6/M01/3E/8C/Cgp9HWCaJWSALZozAAFYkd9C0u4503.png",
        "href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D592%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D592%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"330",
        "hasBuy":false,
        "teacherName":"刘海丰",
        "teacherTitle":"京东集团高级架构师",
        "pruchasedCount":"1.37w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":512,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            1
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":685,
        "title":"数据结构与算法面试宝典",
        "brief":"300+大厂高频真题，一题多解攻克算法面试",
        "image":"https://s0.lgstatic.com/i/image6/M01/0E/27/CioPOWA8SL-Aflz3AAFSxYqXH4o426.png",
        "href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d685%26sid%3d20-h5Url-0",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d685%26sid%3d20-h5Url-0",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"340",
        "hasBuy":true,
        "teacherName":"德鲁伊",
        "teacherTitle":"前微软资深软件工程师",
        "pruchasedCount":"1.87w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":638,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            1,
            2,
            3,
            9,
            6,
            7
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":45,
        "title":"社群运营增长与变现 22 讲",
        "brief":"让你营收翻倍的社群运营操作法则",
        "image":"https://s0.lgstatic.com/i/image6/M00/60/FA/CioPOWGM4YWAKs0MAABnWomZKgQ897.jpg",
        "href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D45%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D45%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"300",
        "hasBuy":false,
        "teacherName":"类延昊（类类）",
        "teacherTitle":"前蚂蚁金服运营专家",
        "pruchasedCount":"4419人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":32,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            5
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":710,
        "title":"趣学设计模式",
        "brief":"告别烂代码，成为编程“艺术家”",
        "image":"https://s0.lgstatic.com/i/image6/M01/19/FA/Cgp9HWBK3LmAVdb-AAAr4wTUvlg055.png",
        "href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d710%26sid%3d20-h5Url-0",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3a%2f%2fkaiwu.lagou.com%2fcourse%2fcourseInfo.htm%3fcourseId%3d710%26sid%3d20-h5Url-0",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"500",
        "hasBuy":true,
        "teacherName":"黄靖锋",
        "teacherTitle":"前京东资深系统架构师",
        "pruchasedCount":"1.61w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":708,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            1,
            2,
            6
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":12,
        "title":"腾讯产品启示录",
        "brief":"36式读懂腾讯产品思维",
        "image":"https://s0.lgstatic.com/i/image6/M00/60/F9/CioPOWGM3L-AEaJSAADA997e8Og374.png",
        "href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D12%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D12%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "openWebToStudy":null,
        "courseType":1,
        "price":"88",
        "originalPrice":null,
        "duration":"300",
        "hasBuy":false,
        "teacherName":"薛军 Boots",
        "teacherTitle":"原腾讯 P12 资深专家，腾讯 391 号员工",
        "pruchasedCount":"2.08w人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":357,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            4,
            9
        ],
        "classCourseType":null,
        "offline":false
    },
    {
        "id":42,
        "title":"运维高手的36项修炼",
        "brief":"前阿里运维专家的实战笔记",
        "image":"https://s0.lgstatic.com/i/image6/M00/61/6C/CioPOWGRvtyAcfwyAACo8Bl1Qqc082.png",
        "href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D42%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "h5Href":"https://www.lagou.com/center/login?forward=https%3A%2F%2Fkaiwu.lagou.com%2Fcourse%2FcourseInfo.htm%3FcourseId%3D42%26sid%3D20-h5Url-0%26lgec_type%3Dwebsite%26lgec_sign%3D86228E00A960E2EB44DCA4027393428B",
        "openWebToStudy":null,
        "courseType":1,
        "price":"98",
        "originalPrice":null,
        "duration":"600",
        "hasBuy":false,
        "teacherName":"牧客",
        "teacherTitle":"前阿里巴巴运维专家",
        "pruchasedCount":"3963人购买",
        "tag":null,
        "promotionType":201,
        "decorateId":122,
        "secKillTag":null,
        "remainSeconds":null,
        "horizontalImage":null,
        "miniCoursePcImage":null,
        "onlineTime":null,
        "onlineTimeDate":null,
        "hasAppointment":false,
        "live":null,
        "liveTime":null,
        "classifyIds":[
            7
        ],
        "classCourseType":null,
        "offline":false
    },
]
